import React from 'react';
import { FlameIcon } from 'lucide-react';
export function ScarcityBar() {
  return <div className="mx-auto w-full max-w-xl rounded-2xl border border-[#f0c7a1] bg-[#fff6ec] p-4 sm:p-5" data-id="element-66" data-mp="2yw2vm54uxh0b">
      <div className="flex items-start gap-3" data-id="element-67" data-mp="2l5fxae30dt4r">
        <FlameIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#d2691e]" aria-hidden="true" data-id="element-68" data-mp="2l4o1p39evveh" />
        <p className="text-left text-[13px] sm:text-sm font-semibold leading-snug text-[#7a3d06]" data-id="element-69" data-mp="2q1o6lauiys40">
          Only <span className="font-extrabold" data-id="element-70" data-mp="2b932fcvq998f">12 spots left</span> at the $27
          promotional price — 188 of 200 already claimed.
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-[#f3ddc6]" role="progressbar" aria-valuenow={94} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-71" data-mp="227ddqet8coec">
        <div className="h-full rounded-full bg-[#e0761f]" style={{
        width: '94%'
      }} data-id="element-72" data-mp="5drzkgg67wkw" />
      </div>
      <p className="mt-2 text-right text-[11px] font-bold uppercase tracking-wider text-[#a6551a]" data-id="element-73" data-mp="33m3c5b8wnhgi">
        94% claimed
      </p>
    </div>;
}